module.exports = __webpack_public_path__ + "media/images/icons/filled/schedule-ee013bc2d1c7f3bc495453aa92b3cf7f.svg";